import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, CardContent } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Image } from 'react-bootstrap';
import { CommonButton, CommonTextField } from '../../CommonComponents';
import LintasAPIService from '../../APIServices/lintasapi';
import { handleLogin, loader } from '../../redux/actions/common';
import { getToken, showToast, formValidation } from '../../Utils';
import logo from '../../assets/images/logo.png'

const apiCall = new LintasAPIService();

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    height: '90vh',
    alignItems: 'center',
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    width: '100%',
    height: '120px',
  },
}));

const Login = ({ login, loading }) => {
  const history = useHistory();
  const classes = useStyles();

  const [state, setState] = useState({
    username: '', password: '',
  });

  const [validation, formValidate] = useState(null)
  const [error, errorMsg] = useState('')

  const handleChange = (val, field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: val,
    }));
  };

  const handleSubmitClick = async () => {
    const { username, password } = state
    const valid = await formValidation(state, 'login')
    if (valid === undefined) {
      loading(true)
      formValidate(null)
      apiCall
        .dashUserLogin(username, password)
        .then((response) => {
          localStorage.setItem('token', response.data.accessToken);
          localStorage.setItem('user', JSON.stringify(response.data.data));
          const token = getToken();
          login()
          loading(false)
          if (token) {
            history.push('/dashboard');
          }
        })
        .catch((err) => {
          loading(false)
          errorMsg(err.response.data.message)
          showToast('error', err.response.data.message);
        });
    } else {
      formValidate(valid)
    }
  };

  const onEnterSubmit = (e) => {
    if (e.keyCode === 13) {
      handleSubmitClick()
    }
  }

  return (
    <Container component="main" maxWidth="xs" className={classes.paper}>
      <CssBaseline />
      <div className={classes.paper}>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.wrapper}>
                <Image src={logo} />
              </Grid>
              <Grid item xs={12}>
                <CommonTextField
                  error={validation && validation.username}
                  handleChange={handleChange}
                  onKeyDown={onEnterSubmit}
                  name="username"
                  label="Username"
                  placeholder="Username"
                  helperText={validation && validation.username && validation.username.length > 0 ? validation.username[0] : ''}
                  required
                  autoComplete="username"
                />
              </Grid>
              <Grid item xs={12}>
                <CommonTextField
                  error={validation && validation.password}
                  handleChange={handleChange}
                  name="password"
                  onKeyDown={onEnterSubmit}
                  label="Password"
                  type="password"
                  placeholder="Password"
                  helperText={validation && validation.password && validation.password.length > 0 ? validation.password[0] : ''}
                  required
                />
              </Grid>
            </Grid>
            <br />
            {error
              ? <Alert severity="error">{error}</Alert>
              : null}
            <br />
            <CommonButton
              fullWidth
              color="primary"
              disabled={!state.username.trim() || !state.password.trim()}
              onClick={() => handleSubmitClick()}
            >
              Login
            </CommonButton>
          </CardContent>
        </Card>
      </div>
    </Container>
  );
}

const mapActions = {
  login: handleLogin,
  loading: loader,
};

export default connect(null, mapActions)(Login);
